import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import AccessDeniedError from './AccessDeniedError'
import NotFoundError from './NotFoundError'
import Result from './Result'
import ResultColor from './ResultColor.enum'
import ServerError from './ServerError'

const RouteBoundary = () => {
  const error = useRouteError() as Error

  const { t } = useTranslation()

  // Report error to Sentry
  if (
    error &&
    !(
      isRouteErrorResponse(error) &&
      (error.status === 404 || error.status === 401 || error.status === 403)
    )
  ) {
    Sentry.captureException(error, {
      tags: {
        errorBoundary: 'RouteBoundary',
      },
    })
  }

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotFoundError />
    }

    if (error.status === 401 || error.status === 403) {
      return <AccessDeniedError status={error.status} />
    }

    if (error.status >= 500) {
      return <ServerError status={error.status} />
    }
  }

  return (
    <Result
      title={t('error.unknown.title')}
      description={t('error.unknown.description')}
      extra={
        error.stack ? (
          <pre className="text-left opacity-50 whitespace-pre-wrap mt-8">
            {error.stack}
          </pre>
        ) : undefined
      }
      variant={ResultColor.BlueRevert}
    />
  )
}

export default RouteBoundary
